import { createAction } from "redux-act";

// Detail
export const MEMCusServiceDetail = createAction("MEM_CusServiceDETAIL");